/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-07 10:26:09
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-26 16:31:56
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\KOLInquiryForQuotation\cells\useDesignatedExpertColumns.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import CopyableNode from '#components/CopyableNode'
import { linkPattern, validateLink } from '#components/SForm/SFormElement/TextAreaShow'
import SupplierVisible from '#features/SupplierVisible'
import { demandSourceGetKolInfoUsingPost } from '#services/api';
import { useDemandOptions } from "@mpc/common/src/features/useDemandOptions";
import { Button, Checkbox, Message, Tag, Tooltip } from '@bedrock/components'
import { useScreenAdapterContext } from '@bedrock/eed-react'
import React, { useMemo, useState } from 'react'
import ProfileOfTheExpertCell from '../cells/ProfileOfTheExpertCell';
import { CooperationCell, NumberOfFans, PlatformCPMCell, PlatformPriceCell, ExpertCell, ExclusiveExpertCell, SupplierListCell, HistoricalCooperationCell }
  from '../cells';
import { ProTable } from '@bedrock/eed-react';
import { SupplierPlatformPriceCell } from '../cells/SupplierPlatformPriceCell';
import { $sType } from '#utils';
import { EllipsisTooltip } from '@mpc/components';
import { cloneDeep } from 'lodash';
import { FilterType } from '@bedrock/eed-react/lib/components/ProFilter/interface';


// 单选框编辑渲染
ProTable.addEditRender(
  'mpc-single-checkbox',
  ({ props, setRow, toggleEditableRowKey, getRowKey }, editable) => ({
    component: editable
      ? ({ children, value, ...rest }) => {
        return (
          <div className="flex flex-col items-start gap-1 justify-between w-full">
            <Checkbox checked={value} {...rest}>
              {children}
            </Checkbox>
            {props.addonAfter?.(value)}
          </div>
        );
      }
      : ({ children, value, ...rest }) => {
        if (rest?.column?.render) {
          return rest?.column?.render?.(value, rest?.row, rest);
        }
        return null;
      },
    props: {
      ...props,
      onChange(e, row, column, rowIndex, ...args) {
        const changedRow = {
          ...row,
          [column.dataIndex as any]: e.target.checked,
        };
        setRow(changedRow);
        props?.onChange?.(e, changedRow, column, rowIndex, ...args);
      },
    },
  })
);


// 供应商平台价格编辑渲染
ProTable.addEditRender(
  'mpc-supplier-platform-cell',
  ({ props, setRow, toggleEditableRowKey, getRowKey }, editable) => ({
    component: SupplierPlatformPriceCell,
    props: {
      ...props,
      view: !editable,
      onChange(e, row, column, rowIndex, ...args) {
        const changedRow = {
          ...row,
          [column.dataIndex as any]: e.target.value,
        };
        setRow(changedRow);
        props?.onChange?.(e, changedRow, column, rowIndex, ...args);
      },
    },
  })
);


const KOL_MAX_NUMBER = 99999999999.99


// 千位符配置
export const thousandSeparatorConfig = {
  max: KOL_MAX_NUMBER,
  toFixed: 2,
  formatter: (value: string | number) => `${(value ?? '')}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
  parser: (value: string) => (value || '').replace(/\$\s?|(,*)/g, ''),
}


interface Props {
  view?: boolean;
  changeData?: (value: any) => void;
  l3_category_id?: any;
  ableSearch?: boolean;
  /** 通用编辑渲染属性 */
  commonEditRenderProp?: any;
}
const useDesignatedExpertColumns = ({
  view,
  changeData,
  l3_category_id,
  ableSearch = false,
  commonEditRenderProp = {},
}: Props) => {
  const [loading, setLoading] = React.useState(false);
  const { viewBase } = useScreenAdapterContext();
  const { optionsMap } = useDemandOptions({
    keys: ['main_platform', 'public_order_new'],
    params: {
      l3_category_id,
    }
  });

  const category = l3_category_id === 221010 ? 'live' : 'text_and_image';
  const mainPlatformOptions = optionsMap?.main_platform?.options;

  const mainPlatformQuoteItemOptions = useMemo(() => {
    const options = optionsMap?.public_order_new?.options || []
    return [...options].sort((a, b) => (a?.index || 0) - (b?.index || 0));
  }, [optionsMap?.public_order_new?.options]);

  const mainPlatformQuoteItemOptionsTree = useMemo(() => {
    const options = cloneDeep(mainPlatformQuoteItemOptions);
    return options?.filter(v => v.level === 0).reduce((acc, v) => {
      v.children = options.filter(n => n.parent_id === v.value);
      acc.push(v);
      return acc;
    }, []);
  }, [mainPlatformQuoteItemOptions]);

  const queryPlatformData = async (val, index) => {
    if (!val) {
      return
    }
    try {
      setLoading(true);
      const res = await demandSourceGetKolInfoUsingPost({
        main_platform_link: [val],
        content_type: l3_category_id,
      });
      const newData = res?.data?.find(s => s.origin_main_platform_link === val);
      if (!newData) {
        changeData(data => data?.map((v, i) => (
          i !== index ? v : ({
            main_platform_link: val,
            import_type: 'FROM_PLAN',
            add_form_not_included: v?.add_form_not_included,
          })
        )))
        setLoading(false);
        Message.info('未匹配到在库达人');
        return
      }
      changeData(data => data?.map((v, i) => (
        i !== index ? v : ({
          import_type: 'FROM_CONTENT',
          add_form_not_included: v?.add_form_not_included,
          ...(newData || {}),
        })
      )))
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoading(false);
    }
  }

  const columnsConfig = {
    index: {
      title: '#',
      dataIndex: 'index',
      width: 50 * viewBase,
      fixed: 'left' as const,
      render: (_, record, index) => `${index + 1}`,
    },
    main_platform_link: {
      title: <SupplierVisible>主平台主页链接</SupplierVisible>,
      width: 240 * viewBase,
      dataIndex: 'main_platform_link',
      editRender: ({ index, row, value }) => {
        const editable = $sType === 'inner' ? !view && row?.add_form_not_included : !view;
        if (editable) {
          return {
            name: 'mpc-textArea',
            editable,
            showReadonlyState: true,
            rule: {
              required: !view,
              validator: (rule, value, callback) => {
                if (!value) {
                  callback('此项必填')
                  return
                }
                const patternResult = validateLink(value);
                if (!patternResult) {
                  callback('格式错误，请输入正确的长链接地址')
                  return
                }
                callback();
              }
            },
            props: {
              size: 'small',
              textAreaProps: {
                placeholder: '请输入长链接',
              },
              inputProps: {
                placeholder: '请输入长链接',
                className: 'w-[216px]',
              },
              onChange: (e) => {
                // 仅内包项目需要查询平台数据
                $sType === 'inner' && queryPlatformData(e.target?.value, index)
              },
            }
          }
        }
        return {
          editable,
          name: 'input',
        }
      },
      render: (v, r) => {
        return <CopyableNode value={v} tipToolTitle="复制链接" >
          <Tooltip title={v}>
            <Button
              type='link'
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                maxWidth: 170 * viewBase,
                color: '#1C80EB',
              }} onClick={() => window.open(v)}>
              {v}
            </Button>
          </Tooltip>
        </CopyableNode>
      },
    },
    main_platform_account: {
      title: <SupplierVisible>主平台发布账号</SupplierVisible>,
      width: 200 * viewBase,
      dataIndex: 'main_platform_account',
      editRender: ({ index, row, value }) => {
        return {
          name: "input",
          editable: $sType === 'inner' ? !view && row?.import_type === 'FROM_PLAN' : !view,
          rule: {
            required: !view,
            message: "此项 必填",
          },
        }
      },
      render: (_, record) => {
        return <EllipsisTooltip
          text={record.main_platform_account || '--'}
          clamp={1}
        />
      },
      searchRender: ableSearch ? {
        type: FilterType.INPUT,
        showCondition: false,
      } : undefined,
    },
    main_platform: {
      title: <SupplierVisible>合作主平台</SupplierVisible>,
      width: 135 * viewBase,
      dataIndex: 'main_platform',
      editRender: ({ index, row, value }) => {
        return {
          rule: {
            required: !view,
            message: "此项 必填",
          },
          name: "select",
          editable: $sType === 'inner' ? !view && row?.import_type === 'FROM_PLAN' : !view,
          props: {
            options: mainPlatformOptions,
            dropdownStyle: {
              width: 150 * viewBase,
            },
            autoMaxHeight: 120 * viewBase,
            allowClear: true,
            showSearch: true,
          }
        }
      },
      searchRender: ableSearch ? {
        type: FilterType.SELECT,
        showCondition: false,
        filterComponentProps: {
          options: mainPlatformOptions,
          multiple: true,
        }
      } : undefined,
    },
    public_order: {
      title: <SupplierVisible>主平台官单/私单</SupplierVisible>,
      width: 160 * viewBase,
      dataIndex: 'public_order',
      render: (v, r) => {
        return v || '--';
      },
      editRender: ({ index, row, value }) => {
        return {
          name: "select",
          editable: !view,
          props: {
            options: mainPlatformQuoteItemOptions?.filter(v => v.level === 0) || [],
            autoMaxHeight: 120 * viewBase,
            allowClear: true,
            showSearch: true,
            onChange: (v) => {
              changeData(data => data?.map((s, i) => {
                if (i !== index) {
                  return s
                }
                return {
                  ...s,
                  public_order: v?.target?.value,
                  main_platform_quote_item: undefined
                }
              }))
            }
          }
        }
      },
      searchRender: ableSearch ? {
        type: FilterType.SELECT,
        showCondition: false,
        filterComponentProps: {
          showSearch: true,
          options: mainPlatformQuoteItemOptions?.filter(v => v.level === 0) || [],
          multiple: true,
        }
      } : undefined,
    },
    main_platform_quote_item: {
      title: <SupplierVisible>主平台报价项目</SupplierVisible>,
      width: 160 * viewBase,
      dataIndex: 'main_platform_quote_item',
      render: (v, r) => {
        return v || '--';
      },
      editRender: ({ index, row, value }) => {
        const options = mainPlatformQuoteItemOptions?.filter(v => !!row?.public_order && v?.parent_id === row?.public_order);
        return {
          name: "select",
          editable: !view,
          props: {
            options,
            autoMaxHeight: 120 * viewBase,
            allowClear: true,
            showSearch: true,
          }
        }
      },
      searchRender: ableSearch ? {
        type: FilterType.SELECT,
        showCondition: false,
        filterComponentProps: {
          showSearch: true,
          options: mainPlatformQuoteItemOptionsTree,
          multiple: true,
          returnOnlyLeaf: true,
        }
      } : undefined,
    },
    number_of_fans: {
      title: '粉丝数',
      dataIndex: 'number_of_fans',
      width: 120 * viewBase,
      align: 'right' as const,
      render: (_, record, index) => <NumberOfFans record={record} />
    },
    historical_cooperation: {
      title: '历史合作(6个月内)',
      dataIndex: 'historical_cooperation',
      width: 280 * viewBase,
      render: (value, record) => (
        <HistoricalCooperationCell
          isEmpty={record?.demand_source_kol_content_vo?.is_coop_last6m === undefined}
          hasHistory={
            record?.demand_source_kol_content_vo?.is_coop_last6m === '1'
          }
          avgPrice={category === 'live' ? record?.demand_source_kol_content_vo?.coop_price_cny_per_live : record?.demand_source_kol_content_vo?.coop_price_cny_per}
          priceCurrency={'RMB'} // 内容营销价格币种固定为人民币，来自服务端
          avgCPM={record?.demand_source_kol_content_vo?.coop_cpm_six_month}
          avgCPMPV={record?.demand_source_kol_content_vo?.cmp_pv_six_month}
          avgCPMUV={record?.demand_source_kol_content_vo?.cmp_uv_six_month}
          category={category}
        />
      ),
    },
    platform_price: {
      title: '平台价格 (来源：商单平台)',
      dataIndex: 'platform_price',
      width: 240 * viewBase,
      render: (_, record) => {
        return <PlatformPriceCell
          starMapPrices={
            record?.demand_source_kol_content_vo?.all_quote_price_cny
          }
          starMapCurrency={'RMB'}
          supplierPrices={record?.platform_quote_price || []}
          supplierCurrency={record.platform_quote_price_currency}
          quoteProject={record?.main_platform_quote_item}
          viewCurrency={'RMB'}
          showRadioGroup={false}
        />
      }
    },
    CPM: {
      title: 'CPM (来源：商单平台)',
      dataIndex: 'CPM',
      width: 240 * viewBase,
      render: (_, record) => {
        return <PlatformCPMCell
          showRadioGroup={false}
          starMapCPMList={
            record?.demand_source_kol_content_vo?.all_cmp_expected
          }
          supplierCPMList={
            record?.demand_source_kol_content_vo?.price_source === '供应商'
              ? record?.platform_cpm
              : []
          }
          quoteProject={
            record?.demand_source_kol_content_vo?.all_quote_price_cny?.[0]
              ?.name || record?.platform_quote_price?.[0]?.name
          }
        />
      }
    },
    profile_of_the_expert: {
      title: <SupplierVisible>达人</SupplierVisible>,
      width: 240 * viewBase,
      dataIndex: 'profile_of_the_expert',
      render: (_, record, index) => {
        return <ProfileOfTheExpertCell record={record} index={index} mainPlatformOptions={mainPlatformOptions} />
      }
    },
    is_exclusive_supplier: {
      title: '是否独家达人',
      dataIndex: 'is_exclusive_supplier',
      width: 80,
      render: (_, record) => <ExclusiveExpertCell record={record} />
    },
    supplier_list: {
      title: '供应商',
      dataIndex: 'supplier_list',
      width: 280,
      render: (_, record) => {
        return <SupplierListCell record={record} />
      }
    },
    cooperation_project: {
      title: <SupplierVisible>合作项目</SupplierVisible>,
      width: 224 * viewBase,
      dataIndex: 'cooperation_project',
      render: (_, record, index) => {
        return <CooperationCell record={record} mainPlatformQuoteItemOptions={mainPlatformQuoteItemOptions} />
      }
    },

    // 供应商报价相关的字段
    $isReported: {
      title: '提报',
      dataIndex: '$isReported',
      width: 100 * viewBase,
      fixed: 'left' as const,
      editRender: () => ({
        name: "mpc-single-checkbox",
        editable: true,
        props: {
          children: '提报',
          disabled: view,
        },
      }),
    },
    exclusiveSign: {
      title: '是否独家签约',
      dataIndex: 'exclusive_sign',
      width: 150 * viewBase,
      render: (_, record) => {
        return <ExclusiveExpertCell value={_} />
      },
      editRender: () => ({
        name: "mpc-single-checkbox",
        editable: !view,
        props: {
          children: '独家签约',
          addonAfter: (value) => {
            if (value) {
              return <div className="text-xs font-normal text-warning-1">请谨慎勾选</div>
            }
          },
        },
      }),
    },
    initialQuote: {
      title: '初次报价',
      dataIndex: 'quote_price',
      width: 240 * viewBase,
      editRender: ({ index, row, value }) => {
        return {
          name: "inputNumber",
          editable: !view,
          rule: {
            required: !view,
            message: "此项 必填",
          },
          props: {
            direction: "vertical",
            allowClear: true,
            addonAfter: null,
            max: KOL_MAX_NUMBER,
            ...thousandSeparatorConfig,
          },
        }
      }
    },
    count: {
      title: '数量',
      dataIndex: 'count',
      width: 120 * viewBase,
      render: (_, record) => {
        return record.count || '--';
      },
      editRender: () => ({
        name: "input",
        editable: !view,
        props: {
          allowClear: true,
        },
      })
    },
    remarkDto: {
      title: '报价备注',
      dataIndex: 'remark_dto',
      width: 350 * viewBase,
      editRender: () => ({
        name: "text_with_upload",
        editable: !view,
        props: {
          textAreaProps: {
            maxLength: 200,
          }
        },
      })
    },
    cpm: {
      title: '15日CPM',
      dataIndex: 'cpm',
      width: 240 * viewBase,
      show: l3_category_id == 221011,
      editRender: ({ index, row, value }) => {
        return {
          rule: {
            required: !view,
            message: "此项 必填",
          },
          name: "inputNumber",
          editable: !view,
          props: {
            direction: "vertical",
            allowClear: true,
            addonAfter: null,
            ...thousandSeparatorConfig,
          },
        }
      }
    },
    cpm_pv: {
      title: '直播CPM(PV)',
      dataIndex: 'cpm_pv',
      width: 240 * viewBase,
      show: l3_category_id == 221010,
      editRender: ({ index, row, value }) => {
        return {
          rule: {
            required: !view,
            message: "此项 必填",
          },
          name: "inputNumber",
          editable: !view,
          props: {
            direction: "vertical",
            allowClear: true,
            addonAfter: null,
            ...thousandSeparatorConfig,
          },
        }
      }
    },
    cpm_uv: {
      title: '直播CPM(UV)',
      dataIndex: 'cpm_uv',
      width: 240 * viewBase,
      show: l3_category_id == 221010,
      editRender: ({ index, row, value }) => {
        return {
          rule: {
            required: !view,
            message: "此项 必填",
          },
          name: "inputNumber",
          editable: !view,
          props: {
            direction: "vertical",
            allowClear: true,
            addonAfter: null,
            ...thousandSeparatorConfig,
          },
        }
      }
    },
    platform_quote_price: {
      title: '平台价格',
      dataIndex: 'platform_quote_price',
      width: 240 * viewBase,
      editRender: ({ index, row, value }) => {
        return {
          name: "mpc-supplier-platform-cell",
          editable: !view,
          props: {
            l3_category_id: l3_category_id,
            type: 'price',
            view: view,
            title: '平台价格',
            ...thousandSeparatorConfig,
          },
        }
      }
    },
    platform_cpm: {
      title: '平台CPM',
      dataIndex: 'platform_cpm',
      width: 240 * viewBase,
      show: l3_category_id == 221011,
      editRender: ({ index, row, value }) => {
        return {
          name: "mpc-supplier-platform-cell",
          editable: !view,
          props: {
            l3_category_id: l3_category_id,
            type: 'cpm',
            view: view,
            title: '平台CPM',
            ...thousandSeparatorConfig,
          },
        }
      }
    },
    platform_cpm_pv: {
      title: '平台CPM(PV)',
      dataIndex: 'platform_cpm_pv',
      show: l3_category_id == 221010,
      width: 240 * viewBase,
      editRender: ({ index, row, value }) => {
        return {
          name: "mpc-supplier-platform-cell",
          editable: !view,
          props: {
            l3_category_id: l3_category_id,
            type: 'cpm',
            view: view,
            title: '平台CPM(PV)',
            ...thousandSeparatorConfig,
          },
        }
      }
    },
    platform_cpm_uv: {
      title: '平台CPM(UV)',
      dataIndex: 'platform_cpm_uv',
      show: l3_category_id == 221010,
      width: 240 * viewBase,
      editRender: ({ index, row, value }) => {
        return {
          name: "mpc-supplier-platform-cell",
          editable: !view,
          props: {
            l3_category_id: l3_category_id,
            type: 'cpm',
            view: view,
            title: '平台CPM(UV)',
            ...thousandSeparatorConfig,
          },
        }
      }
    },
  }
  // 判断如果columnsConfig.editRender为函数，则包装这个函数，如果columnsConfig.editRender为对象，则合并commonEditRenderProp
  const warppedColumnsConfig = Object.keys(columnsConfig).reduce((acc, key) => {
    const column = columnsConfig[key];
    if (typeof column.editRender === 'function') {
      acc[key] = {
        ...column,
        editRender: function (...args) {
          const result = column.editRender(...args, commonEditRenderProp);
          return {
            ...result,
            ...commonEditRenderProp,
            props: {
              ...result.props,
              ...(commonEditRenderProp?.props || {}),
            },
          }
        }
      }
    } else if (typeof column.editRender === 'object') {
      // 如果是对象，则合并commonEditRenderProp
      acc[key] = { ...column,
        editRender: {
          ...(column?.editRender || {}),
          ...commonEditRenderProp,
          props: {
            ...(column.editRender?.props || {}),
            ...(commonEditRenderProp?.props || {}),
          },
        },
       };
    } else {
      acc[key] = column;
    }
    return acc;
  }, {});

  return {
    columnsConfig: warppedColumnsConfig as typeof columnsConfig,
    loading,
  }
}

export default useDesignatedExpertColumns;
